module.exports = __webpack_public_path__ + "static/media/galerija_2015 (5).4c73108e.jpg";